var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"tree-card"},[_c('el-tree',{ref:"repairTree",attrs:{"data":_vm.treeData,"node-key":"id","props":_vm.defaultProps,"default-expand-all":true},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }